/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FormController from "../../../FormController/FormController";
import { getGamesByDayOfWeek } from "../../../../features/cms/cmsSlice";
import FormTitle from "../../../FormTitle/FormTitle";
import CustomTabs from "../../components/CustomTabs/idnex";
import { GameItemList } from "../../components/GameItemList/GameItemList";

const ByDayOfWeek = () => {
  const history = useHistory();
  const { type } = useSelector((state) => state?.singleGroup);
  const games = useSelector(getGamesByDayOfWeek);

  const [tabs, setTabs] = useState();

  const weekDays = {
    Monday: "Mondays",
    Tuesday: "Tuesdays",
    Wednesday: "Wednesdays",
    Thursday: "Thursdays",
    Friday: "Fridays",
    Saturday: "Saturdays",
    Sunday: "Sundays",
  };
  useEffect(() => {
    if (!type) history.push("/");

    if (!tabs) {
      const _tabs = Object.keys(games).map((d) => {
        return {
          id: d,
          // label: d,
          label: weekDays[d],
          comp: <GameItemList games={games[d]} />,
        };
      });
      setTabs(_tabs);
    }
  }, [games, history, tabs, type]);

  return (
    <div>
      <FormTitle title="By Day of Week" />
      <div>
        {tabs && (
          <CustomTabs
            tabs={tabs}
            activeTab={history.location.state?.data}
            trackingTitle="Games By Day Of Week"
          />
        )}
      </div>
      <FormController
        backTo="/ticket-single-group/by-day-of-week-landing"
        startOver="/"
        showBack
        showStartOver
      />
    </div>
  );
};

export default ByDayOfWeek;
